import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { LOADER_OFF, LOADER_ON, PatientPayersActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const { UPDATE_PATIENT_PAYER_REQUEST, UPDATE_PATIENT_PAYER_SUCCESS, UPDATE_PATIENT_PAYER_FAILURE } =
  PatientPayersActions;

function* updatePatientPayer(action: any): SagaReturnType<any> {
  try {
    const response = yield call(patientService.updatePatientPayer, action.payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_PATIENT_PAYER_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_PATIENT_PAYER_FAILURE, payload: error });
  }
}

function* updatePatientPayerSaga() {
  yield takeEvery(UPDATE_PATIENT_PAYER_REQUEST, updatePatientPayer);
}

export default updatePatientPayerSaga;
